import { ContentProperties, EFileType, MetadataSerialization } from '@adaptiva/metadata/common';
import { OverlayComponent } from '@adaptiva/widgets/overlay';
import { ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { BaseContentAuthoringProperties } from '../base-content-authoring-properties';

@Component({
	standalone: false,
	selector: 'ada-content-properties',
	templateUrl: './content-properties.component.html',
	styleUrls: ['../base-content-authoring-properties/base-content-authoring-properties.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContentPropertiesComponent extends BaseContentAuthoringProperties<ContentProperties> {
	@ViewChild('UploadOverlay')
	public uploadOverlay: OverlayComponent;
	
	public override fileType: EFileType = EFileType.INSTALL;

	public propertyConstructor: MetadataSerialization.Deserializable<ContentProperties> = ContentProperties;

}
